import React from "react";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import { useFinalisation } from "src/pages/finalisation/FinalisationContext";
import { useAppText } from "src/commun/composants/AppText";

export type CodeTelephoneFinalisationProps = {
  pageSuivante: (data: any) => void;
};


const CodeTelephoneFinalisation = ({ pageSuivante }: CodeTelephoneFinalisationProps) => {

  const { tString } = useAppText();
  const [value] = useFinalisation();

  return (
    <AppRow>
      <AppCol>
        {tString("compte.mon.profile.mobile.code.recu.valide")}
      </AppCol>
      <AppCol>
        <input
          className="btn__primary mt-3 btn--full--xs"
          type="submit"
          name="submit"
          onClick={() => pageSuivante(value.etapes[1].data)}
          value={tString("action.continuer")}
        />
      </AppCol>
    </AppRow>
  );

};

export default CodeTelephoneFinalisation;